export const TRANSACTION_TABLE_HEADERS = [
  {
    text: 'entities.invoices.attributes.id',
    value: 'id',
    sortable: false,
    width: 200,
  },
  {
    text: 'entities.invoices.attributes.coins',
    value: 'coins_given',
    sortable: false,
    width: 150,
  },
  {
    text: 'entities.invoices.attributes.byUser',
    value: 'seller_user_id',
    sortable: false,
    width: 250,
  },
  {
    text: 'entities.invoices.attributes.toUser',
    value: 'buyer_user_id',
    sortable: false,
    width: 250,
  },
  {
    text: 'miscellaneous.createdAt',
    value: 'created_at',
    sortable: false,
    width: 200,
  },
  {
    text: 'miscellaneous.actions',
    value: 'actions',
    sortable: false,
  },
]
